import * as effects from 'redux-saga/effects';
import { chatActions } from '../../actions';
import { throwError } from '../../../throwError';
import { handleError } from '../../../handleError';
import { api } from '../../../../server/api';

export function* deleteChannel({ payload }) {
  try {
    yield effects.put(chatActions.startChecking());
    const response = yield effects.apply(api, api.delete, [
      {
        endpoint: `chats/${payload}/`,
      },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    yield effects.put(chatActions.fetchChannels());
    yield effects.put(chatActions.clearMessages());
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(chatActions.stopChecking());
  }
}
